import queryString from 'query-string';
import http from '../httpConfig';
import { AddEditApi, ListStockistBranch } from '../interfaces/stockist.interface';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';

const list = (payload: ListStockistBranch) => {
  const { searchText, status, stockist_id, ...others } = payload;
  const paging = buildPagingResponse(others);
  const queryParams: any = {
    ...paging,
    search: searchText,
    status,
    stockist_id,
  };

  const url = `${API_ENDPOINTS.listStockistBranches}?${queryString.stringify(queryParams)}`;
  return http.get(url);
};

const add = (payload: AddEditApi) => {
  return http.post(API_ENDPOINTS.addStockistBranch, payload);
};

const edit = (id: string, payload: AddEditApi) => {
  return http.put(`${API_ENDPOINTS.editStockistBranch}/${id}`, payload);
};

const deleteBranch = (id: string) => {
  return http.delete(`${API_ENDPOINTS.deleteStockistBranch}/${id}`);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.getStockistBranch}/${id}`);
};

const StockistBranchService = {
  list,
  add,
  edit,
  delete: deleteBranch,
  get,
};

export default StockistBranchService;
